import { render, staticRenderFns } from "./imodalopenNote.vue?vue&type=template&id=47908f4c&"
import script from "./imodalopenNote.vue?vue&type=script&lang=js&"
export * from "./imodalopenNote.vue?vue&type=script&lang=js&"
import style0 from "./imodalopenNote.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports